module.exports = __webpack_public_path__ + "img/P150T_weapon_78.014125a0.png";